import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";
import { ReactNode } from "react";

function TaskManagementDevOnly({ children }: { children: ReactNode }) {
  const isTaskManagementDevEnabled = useFlag(
    FLAGS.ENABLE_TASK_MANAGEMENT_DEVELOPER
  );

  if (isTaskManagementDevEnabled) {
    return children;
  }
  return null;
}

export default TaskManagementDevOnly;
